import axios from 'axios';
const API_URL = process.env.REACT_APP_API;

export async function getAllAsignadas(filters: any) {
  const params = new URLSearchParams();
  if (filters.iccid) params.set('iccid', filters.iccid);
  if (filters.type) params.set('type', filters.type);

  const queryString = params.toString();
  const url = `${API_URL}catalogos/zonas/assigned${
    queryString ? `?${queryString}` : ''
  }`;

  const response = await axios.get(url);
  const data = response.data.doc.data;
  return data;
}
